import { Tab, TabContainer } from '@collab/molecules';

import ColorBlock from 'atoms/ColorBlock';
import { isDarkText } from 'utils/isDarkText';

import useColorChart, {
  ColorChartItem,
  ColorChartVariants,
  ColorModels,
} from './useColorChart';

const ColorChart: React.FC<{
  variant: ColorChartVariants;
}> = ({ variant }) => {
  const { chartTabs, title, colors } = useColorChart(variant);

  return (
    <TabContainer title={title} wideHeaderItem>
      {chartTabs.map((model) => (
        <Tab key={model} title={model.toUpperCase()}>
          <ColorBlocks colors={colors} model={model} />
        </Tab>
      ))}
    </TabContainer>
  );
};

const ColorBlocks: React.FC<{
  colors: ColorChartItem[];
  model: ColorModels;
}> = ({ colors, model }) => (
  <>
    {colors
      .filter(({ colorModels }) => colorModels[model])
      .map(({ colorModels, border }) => (
        <ColorBlock
          key={colorModels[model]}
          label={colorModels[model]}
          color={colorModels.hex}
          darkText={isDarkText(colorModels.hex)}
          hasBorder={border}
        />
      ))}
  </>
);

export default ColorChart;
